import React, { useEffect } from "react";
import AOS from "aos"; // Import AOS for animations
import "aos/dist/aos.css"; // Import AOS CSS

const ContactInfo = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS
  }, []);

  return (
    <section className="py-10 bg-gray-50" id="contact">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-6" data-aos="fade-up">
          Contact Us
        </h2>
        <p className="text-center text-gray-600 mb-8" data-aos="fade-up">
          We’d love to hear from you! Reach out for any inquiries or support.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Contact Details */}
          <div
            className="bg-white rounded-lg shadow-lg p-6"
            data-aos="fade-right"
          >
            <h3 className="text-xl font-semibold mb-4">Contact Details</h3>
            <ul className="space-y-4">
              <li className="flex items-center">
                <span className="material-icons text-blue-600 mr-2">phone</span>
                <span className="text-gray-800">+1 (123) 456-7890</span>
              </li>
              <li className="flex items-center">
                <span className="material-icons text-blue-600 mr-2">email</span>
                <span className="text-gray-800">info@example.com</span>
              </li>
              <li className="flex items-center">
                <span className="material-icons text-blue-600 mr-2">
                  location_on
                </span>
                <span className="text-gray-800">
                  123 Main St, City, Country
                </span>
              </li>
            </ul>
          </div>

          {/* Contact Form */}
          <div
            className="bg-white rounded-lg shadow-lg p-6"
            data-aos="fade-left"
          >
            <h3 className="text-xl font-semibold mb-4">Get in Touch</h3>
            <form>
              <div className="mb-4">
                <label className="block text-gray-700 mb-1" htmlFor="name">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  className="w-full p-2 border border-gray-300 rounded hover:border-blue-500 focus:outline-none focus:ring focus:ring-blue-300"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 mb-1" htmlFor="email">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full p-2 border border-gray-300 rounded hover:border-blue-500 focus:outline-none focus:ring focus:ring-blue-300"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 mb-1" htmlFor="message">
                  Message
                </label>
                <textarea
                  id="message"
                  className="w-full p-2 border border-gray-300 rounded hover:border-blue-500 focus:outline-none focus:ring focus:ring-blue-300"
                  rows="4"
                  required
                />
              </div>
              <button
                type="submit"
                className="w-full bg-blue-600 text-white font-bold py-2 rounded hover:bg-blue-700 transition duration-300"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>

        {/* Social Media Links */}
        <div className="mt-8 text-center" data-aos="fade-up">
          <h3 className="text-xl font-semibold mb-4">Follow Us</h3>
          <div className="flex justify-center space-x-4">
            <a
              href="#"
              className="text-blue-600 hover:text-blue-800 transition duration-300"
            >
              <span className="material-icons">facebook</span>
            </a>
            <a
              href="#"
              className="text-blue-600 hover:text-blue-800 transition duration-300"
            >
              <span className="material-icons">twitter</span>
            </a>
            <a
              href="#"
              className="text-blue-600 hover:text-blue-800 transition duration-300"
            >
              <span className="material-icons">instagram</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactInfo;
